export const LEGACY_FULLY_COMPLETE_STATUS = "100%"
export const LEGACY_FULLY_COMPLETE_TEXT = "Fully Complete"
export const COMPLETE_STATUS = "Complete"

/** Legacy DB/API value; normalized to OVERALL_STATUS_NO_ASSISTANCE_LABEL for display and comparisons. */
export const OVERALL_STATUS_NO_ASSISTANCE_LEGACY = "No Needs/Out of Scope"
/** Canonical stored and display value (matches DB after migration). */
export const OVERALL_STATUS_NO_ASSISTANCE_LABEL = "No Assistance Required"

export function normalizeOverallStatus(status: string | null | undefined): string {
  const trimmed = (status ?? "").trim()
  if (!trimmed) return ""
  if (
    trimmed === LEGACY_FULLY_COMPLETE_STATUS ||
    trimmed === LEGACY_FULLY_COMPLETE_TEXT
  ) {
    return COMPLETE_STATUS
  }
  if (trimmed === OVERALL_STATUS_NO_ASSISTANCE_LEGACY) {
    return OVERALL_STATUS_NO_ASSISTANCE_LABEL
  }
  return trimmed
}

/** Display string for overall status (same as normalize for all current cases). */
export function displayOverallStatusLabel(status: string | null | undefined): string {
  return normalizeOverallStatus(status)
}

/**
 * Short label for homeowners list/table badges only. Does not change stored values, URLs, or filters.
 * Relief / Rebuilding / Goodwill use the same phrase as overall for this status.
 */
export function compactStatusLabelForHomeownersList(label: string): string {
  if (label === OVERALL_STATUS_NO_ASSISTANCE_LABEL) return "NAR"
  if (label === "Materials Only Complete") return "Materials Complete"
  return label
}

export function normalizeOverallStatusList(statuses: string[]): string[] {
  const normalized = statuses
    .map((status) => normalizeOverallStatus(status))
    .filter(Boolean)
  return Array.from(new Set(normalized))
}
